import { render, staticRenderFns } from "./Astrazeneca.vue?vue&type=template&id=5aaeded4&"
import script from "./Astrazeneca.vue?vue&type=script&lang=js&"
export * from "./Astrazeneca.vue?vue&type=script&lang=js&"
import style0 from "./Astrazeneca.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports